import { c as _c } from "react/compiler-runtime";
import { PaymentProcessorEnum, Tooltip, getPaymentProcessorTitle, toast, useTranslation as useUiTranslation } from '@systemeio/ui';
import { Integration } from 'modules/profile/payment-gateways/components/integration';
import { useConnectedPaymentIntegrations } from 'modules/profile/payment-gateways/hooks/use-connected-payment-integrations';
import { cashOnDeliveryDisconnect } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/api';
import CashOnDeliveryCreateModal from 'modules/profile/payment-gateways/integrations/cash-on-delivery/components/cash-on-delivery-create-modal';
import CashOnDeliveryEditModal from 'modules/profile/payment-gateways/integrations/cash-on-delivery/components/cash-on-delivery-edit-modal';
import { CashOnDeliveryPaymentIntegrationInterface } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/types';
import { getCashOnDeliveryHelpPageLink } from 'modules/profile/payment-gateways/integrations/cash-on-delivery/utils';
import React, { FC, useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import useUser from 'shared/hooks/use-user';
import { BinIcon } from '@systemeio/ui/icons';
export const CashOnDelivery: FC = () => {
  const $ = _c(30);
  const {
    user
  } = useUser();
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    getConnectedPaymentIntegration,
    removePaymentIntegration
  } = useConnectedPaymentIntegrations();
  const [deleteOpened, setDeleteOpened] = useState(false);
  let t0;
  if ($[0] !== getConnectedPaymentIntegration) {
    t0 = getConnectedPaymentIntegration({
      processor: PaymentProcessorEnum.CashOnDelivery
    });
    $[0] = getConnectedPaymentIntegration;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const cashOnDeliveryIntegration = t0;
  let t1;
  if ($[2] !== removePaymentIntegration || $[3] !== t) {
    t1 = async () => {
      await cashOnDeliveryDisconnect();
      await removePaymentIntegration({
        processor: PaymentProcessorEnum.CashOnDelivery
      });
      toast.success(t("dashboard.settings.payment-gateways.cash_on_delivery.remove_toast_notification"));
    };
    $[2] = removePaymentIntegration;
    $[3] = t;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onDelete = t1;
  let t2;
  if ($[5] !== tUi) {
    t2 = getPaymentProcessorTitle(PaymentProcessorEnum.CashOnDelivery, tUi);
    $[5] = tUi;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t2) {
    t3 = <span className="whitespace-nowrap text-2xl font-bold text-black">{t2}</span>;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = user?.dashboardLocale;
  let t5;
  if ($[9] !== t4) {
    t5 = getCashOnDeliveryHelpPageLink(t4);
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== tUi) {
    t6 = getPaymentProcessorTitle(PaymentProcessorEnum.CashOnDelivery, tUi);
    $[11] = tUi;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t6) {
    t7 = {
      integration: t6
    };
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t || $[16] !== t7) {
    t8 = <TransLoco t={t} i18nKey="dashboard.settings.payment_gateways.help_article_label" values={t7} />;
    $[15] = t;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t5 || $[19] !== t8) {
    t9 = <a className="primary-link" href={t5} target="_blank" rel="noreferrer">{t8}</a>;
    $[18] = t5;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== cashOnDeliveryIntegration || $[22] !== deleteOpened || $[23] !== onDelete || $[24] !== t) {
    t10 = cashOnDeliveryIntegration ? <div className="flex w-full justify-between gap-3 overflow-hidden"><div className="flex flex-col gap-1 truncate">{!cashOnDeliveryIntegration.readyToUse && <p className="flex gap-1">{t("dashboard.settings.payment-gateways.integration_in_progress")}</p>}<CashOnDeliveryEditModal instructions={cashOnDeliveryIntegration.details.instructions} /></div><Tooltip mode="hover" label={t("dashboard.settings.payment-gateways.remove_integration", {
        payment: t("dashboard.settings.payment-gateways.cash-on-delivery-integration").toLowerCase()
      })} wrapperClassName="flex items-center" className="h-fit"><button className="group outline-hidden" onClick={() => setDeleteOpened(true)}><BinIcon className="group-focus-visible:fill-danger hover:fill-danger main-transition-colors h-[16px] w-[16px]" /></button></Tooltip><ConfirmationModal title={t("dashboard.settings.payment-gateways.remove_integration_description", {
        payment: t("dashboard.settings.payment-gateways.cash-on-delivery-integration").toLowerCase()
      })} confirmationText={t("dashboard.settings.payment-gateways.remove_payment_text.cash_on_delivery")} opened={deleteOpened} onClose={() => setDeleteOpened(false)} onConfirm={onDelete} /></div> : <CashOnDeliveryCreateModal />;
    $[21] = cashOnDeliveryIntegration;
    $[22] = deleteOpened;
    $[23] = onDelete;
    $[24] = t;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t3 || $[28] !== t9) {
    t11 = <Integration logo={t3} additionalInfo={t9}>{t10}</Integration>;
    $[26] = t10;
    $[27] = t3;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};